<template>
  <v-layout align-center justify-center>
    <v-flex xs10>
      <v-card class="px-5 py-5">
          Veuillez choisir un project sur la gauche, ou en créer un nouveau
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'home',
  components: {
  }
}
</script>
